export default [
    {
        name: 'subfamily',
        type: 'text-field',
        flex: {
            sm6: true,
            lg10: true,
        },
        props: {
            label: 'Subfamilia',
            // rules: [required],
        },
    },
]
